import { Body, ListItem, onEnterKey } from "@songtradr-one/components-frontend";
import { Flex } from "@songtradr-one/shared-frontend";
import { StaticItem } from "../user-menu-item/UserMenuItem.Parts";
import { Props, text } from "./UserMenuSubscription.Parts";

export const UserMenuSubscription = ({
  companyName,
  planName,
  manageUrl,
  canSubscribe,
  onOpen,
}: Props) => {
  const content = (
    <Flex $direction="column" $gap="0" $fullWidth>
      <Body variant="small-strong">{companyName}</Body>
      <Body color="shade400" variant="small">
        {planName ?? (canSubscribe ? text.subscribeNow : text.noActivePlan)}
      </Body>
    </Flex>
  );

  // Informational, like the name/email entry, unless it can be managed or subscribed to
  if (!manageUrl && !canSubscribe) {
    return <StaticItem>{content}</StaticItem>;
  }

  return (
    <ListItem onClick={onOpen} onKeyDown={onEnterKey(onOpen)}>
      {content}
    </ListItem>
  );
};
